import { jsx as _jsx } from "react/jsx-runtime";
import { Menu, MenuItem } from '@blueprintjs/core';
import { Toolbar, } from 'react-science/ui';
export function ToolbarPopoverItem(props) {
    const { options, onClick, ...itemProps } = props;
    return (_jsx(Toolbar.PopoverItem, { content: _jsx(Menu, { children: options.map((option) => {
                const { data, ...otherOptions } = option;
                return (_jsx(MenuItem, { ...otherOptions, onClick: () => onClick(data) }, JSON.stringify(option)));
            }) }), itemProps: itemProps }));
}
